/**
 * Facebetter Constants and Enums
 * Platform-agnostic constants
 */

/**
 * Beauty type enumeration
 */
export const BeautyType = {
  Basic: 0,            // 基础美颜
  Reshape: 1,         // 面部重塑
  Makeup: 2,          // 美妆效果
  VirtualBackground: 3 // 虚拟背景
};

/**
 * Basic beauty parameter enumeration
 */
export const BasicParam = {
  Smoothing: 0,   // 磨皮
  Sharpening: 1,   // 锐化
  Whitening: 2,   // 美白
  Rosiness: 3     // 红润
};

/**
 * Face reshape parameter enumeration
 */
export const ReshapeParam = {
  FaceThin: 0,    // 瘦脸
  FaceVShape: 1,  // V脸
  FaceNarrow: 2,  // 窄脸
  FaceShort: 3,   // 短脸
  Cheekbone: 4,   // 颧骨
  Jawbone: 5,     // 下颌骨
  Chin: 6,        // 下巴
  NoseSlim: 7,    // 瘦鼻梁
  EyeSize: 8,     // 大眼
  EyeDistance: 9  // 眼距
};

/**
 * Makeup parameter enumeration
 */
export const MakeupParam = {
  Lipstick: 0,    // 口红
  Blush: 1        // 腮红
};

/**
 * Background mode enumeration
 */
export const BackgroundMode = {
  None: 0,        // 无背景处理
  Blur: 1,        // 模糊背景
  Image: 2        // 背景图片替换
};

/**
 * Process mode enumeration
 */
export const ProcessMode = {
  Image: 0,       // 图片模式
  Video: 1        // 视频模式
};

/**
 * Virtual background options class
 * Matches the C++/Java/OC API design
 */
export class VirtualBackgroundOptions {
  /**
   * Creates a new VirtualBackgroundOptions instance
   * @param {Object} [options] - Options object
   * @param {number} [options.mode] - Background mode (use BackgroundMode enum)
   * @param {ImageData|HTMLImageElement|HTMLCanvasElement} [options.backgroundImage] - Background image (required when mode is Image)
   */
  constructor(options = {}) {
    this.mode = options.mode !== undefined ? options.mode : BackgroundMode.None;
    this.backgroundImage = options.backgroundImage || null;
  }

  /**
   * Validates the options
   * @returns {boolean} True if valid
   */
  isValid() {
    if (this.mode === BackgroundMode.Image) {
      return this.backgroundImage !== null;
    }
    return true;
  }
}

